





























import { Component, Vue } from "vue-property-decorator";
import Page from "@/components/for-page-grid/Page.vue";
import {getBaseUrl, getOrgAddress, getOrgInn, getOrgName} from "@/lib/org_info";

@Component({
  components: { Page },
  methods: {getBaseUrl, getOrgInn, getOrgAddress, getOrgName},
})
class Consent extends Vue {

}

export default Consent;
